module.exports = __webpack_public_path__ + "img/floor-result.86a0cce1.png";